import { axiosInstance } from 'utils/AxiosInstance';

export type PublicAnalyzeRequest = {
  file: File;
  type: string;
  climate: string;
  terrain: string;
  singleBlockPerFloor: boolean;
  version?: string;
};

export type PublicAnalyzeResponse = {
  success: boolean;
  parseErrors?: Record<string, string> | null;
  convertErrors?: unknown;
  codeErrors?: unknown;
  summary?: {
    totalChecks?: number;
    matches?: number;
    qualityChecks?: number;
    qualityMatches?: number;
    mismatches?: number;
    hardMismatches?: number;
  } | null;
  mismatchesBySection?: Array<{
    section: string;
    mismatches: Array<Record<string, unknown>>;
  }> | null;
  timeImpact?: {
    beforeUploadMinutes?: number;
    afterUploadMinutes?: number;
    totalImpactMinutes?: number;
    honestCorrectionMinutes?: number;
    simMinutes?: number;
    reportMinutes?: number;
    unitCount?: number;
  } | null;
  suggestedSkipOverwrite?: boolean;
  idfVersion?: string | null;
  nameFixes?: Array<{
    name: string;
    fixed: string;
    kind: string;
  }>;
  errors?: Record<string, string>;
};

export const analyzePublicIdf = async (
  req: PublicAnalyzeRequest
): Promise<PublicAnalyzeResponse> => {
  const form = new FormData();
  form.append('idf', req.file);
  form.append('type', req.type);
  form.append('climate', req.climate);
  form.append('terrain', req.terrain);
  form.append('singleBlockPerFloor', String(!!req.singleBlockPerFloor));
  form.append('version', req.version || '4.x.x');

  const response = await axiosInstance.post<PublicAnalyzeResponse>(
    '/public/analyze-idf',
    form,
    {
      // Let the browser/axios set multipart boundary (do not force application/json)
      headers: { 'Content-Type': 'multipart/form-data' },
      transformRequest: [
        (data, headers) => {
          if (data instanceof FormData && headers) {
            delete (headers as any)['Content-Type'];
          }
          return data;
        },
      ],
      timeout: 10 * 60 * 1000,
    }
  );
  return response.data;
};
